export default {
  brand: 'Laplace x GTM',
  login: 'Войти',
  getStarted: 'Начать',

  heroKicker: 'AI SDR для B2B-продаж',
  heroHeadline:
    'Найдите своих клиентов. <accent>Узнайте, что им написать.</accent>',
  heroSubtitle:
    'Укажите сайт — через две минуты увидите <strong>реальных покупателей и первые письма</strong> им.',
  urlLabel: 'Сайт вашей компании',
  urlPlaceholder: 'yourcompany.com',
  submit: 'Найти лидов',
  submitting: 'Запускаем…',
  submitHint: 'Предпросмотр бесплатно. Без регистрации и карты.',

  progressTitle: 'AI-сотрудник уже работает',
  progressHint: 'Обычно это занимает 20–40 секунд.',
  step_research_company: 'Изучаем вашу компанию',
  step_finding_leads: 'Ищем лиц, принимающих решения',
  step_writing_emails: 'Пишем персональные письма',

  profileTitle: 'Что мы узнали о {{company}}',
  icpTitle: 'Кто у вас покупает',
  icpIndustries: 'Отрасли',
  icpJobTitles: 'Кто принимает решение',
  icpCompanySizes: 'Размер компании',
  icpLocations: 'Регионы',
  icpPainPoints: 'Какие проблемы вы решаете',
  employees: '{{size}} сотрудников',
  researchCoverage: 'Прочитали {{count}} стр. на {{domain}}',
  researchSitemap: 'в карте сайта {{pages}}',
  researchLlmsTxt: 'включая llms.txt',
  peopleTitle: 'Основатели и руководство',
  personSource: 'источник',
  keyFeatures: 'Ключевые возможности',
  namedCustomers: 'Клиенты, которых они называют',
  socialProfiles: 'Официальные профили',

  leadsTitle: 'Подходящих лидов: {{count}}',
  leadsHint: 'Контакты и полный список откроются после запуска кампании.',
  leadHasLinkedin: 'LinkedIn',
  leadHasVerifiedEmail: 'Email проверен',
  nextTitle: 'От плана к продажам',
  next_send: 'Свяжитесь с потенциальными клиентами',
  next_meetings: 'Переведите переписку во встречи',
  next_learn: 'Улучшите следующую кампанию',
  outreachStart: 'Запустить рассылку',
  outreachSend: 'Запустить и отправить',
  outreachTo: 'Кому',
  outreachSubject: 'Тема',
  outreachBody: 'Черновик письма',
  outreachLinkedin: 'Профиль {{name}} в LinkedIn',
  outreachFromSite: 'с сайта компании',
  outreachSourcesChecked_one: 'проверено в {{count}} источнике',
  outreachSourcesChecked_few: 'проверено в {{count}} источниках',
  outreachSourcesChecked_many: 'проверено в {{count}} источниках',
  outreachSourcesChecked_other: 'проверено в {{count}} источниках',
  outreachNoneFound: 'Рабочие email для этих людей пока не найдены.',
  sampleDraftNoRecipient: 'Нет реального получателя — только пример',
  checkoutPreparing: 'Готовим оформление…',
  outreachRecipients: 'Люди с готовыми письмами',
  outreachContinue: 'Отправить',
  emailStatus_valid: 'проверен',
  emailStatus_catch_all: 'Доставка не подтверждена',
  emailStatus_unknown: 'не проверен',
  emailStatus_invalid: 'недоставляем',
  emailStatusHint_valid: 'Адрес прошёл проверку.',
  emailStatusHint_catch_all:
    'Домен принимает письма на любые адреса, поэтому доставку нельзя подтвердить.',
  emailStatusHint_unknown: 'Адрес ещё не проверен.',
  emailStatusHint_invalid:
    'На этот адрес письма не доходят, писать на него не будем.',
  emailHiddenUntilCampaign: 'Адрес откроется после запуска кампании.',
  leadLocked: 'Откроется после запуска',
  leadWithEmail: 'Письмо готово',
  sampleData:
    'Демо-данные: провайдер контактов ещё не подключён, эти люди — для примера.',

  emailsTitle: 'Письма готовы к отправке',
  emailTo: 'Кому: {{name}}, {{title}}, {{company}}',
  emailSubject: 'Тема',

  estimateTitle: 'Что даст ${{budget}}',
  estimateReplies: 'Положительных ответов',
  estimateMeetings: 'Встреч',
  estimateNote:
    'Оценка по отраслевым бенчмаркам исходящих B2B-писем, а не гарантия.',

  checkoutBalanceLabel: 'Сумма',
  checkoutAmountLabel: 'Сумма, USD',
  checkoutPayTitle: 'Пополнить баланс',
  checkoutAuthTitle: 'Аккаунт',
  checkoutAuthText: 'Зарегистрируйтесь или войдите, чтобы продолжить.',
  checkoutAuthContinue: 'Продолжить',
  startTitle: 'Готовим ваше рабочее пространство GTM',
  startText: 'Переносим анализ, кампании, лидов и черновики.',
  startErrorTitle: 'Рабочее пространство пока не готово',
  startErrorText: 'Ваше демо сохранено. Попробуйте ещё раз через минуту.',
  startRetry: 'Попробовать ещё раз',
  startOpenApp: 'Открыть Laplace',
  checkoutSignedInText: 'Вы вошли. Баланс пополнится в этом аккаунте.',
  checkoutAccountTitle: 'Аккаунт',
  checkoutPayText: 'Выберите сумму и продолжите.',
  checkoutCardNumber: 'Номер карты',
  checkoutCardExpiry: 'Срок действия',
  checkoutCardCvc: 'CVC',
  checkoutCardNumberError: 'Введите номер карты, указанный в поле.',
  checkoutCardExpiryError: 'Введите срок, указанный в поле.',
  checkoutCardCvcError: 'Введите CVC, указанный в поле.',
  checkoutAgreement:
    'Оплачивая, вы соглашаетесь с <terms>Условиями использования</terms> и <refund>Политикой возврата</refund>: кредиты возвращаются только до отправки первого письма.',
  checkoutConfirm: 'Подтвердить и продолжить',
  checkoutError: 'Что-то пошло не так. Попробуйте ещё раз.',
  checkoutDoneTitle: 'Баланс пополнен',
  checkoutDoneText: '${{amount}} зачислено на ваш баланс.',
  checkoutDoneWorkspace: 'GTM-workspace готов.',
  checkoutOpenWorkspace: 'Открыть GTM-workspace',
  checkoutClose: 'Готово',
  ctaTitle: 'Запустить кампанию',
  ctaHowItWorks: 'Как работает кампания',
  ctaText:
    'Купите кредиты от $50 — кампании, лиды и черновики перенесутся в ваше рабочее место. Письма уходят с прогретых ящиков, закреплённых за вашим аккаунтом, и ничего не отправляется, пока вы не нажмёте «Отправить».',
  ctaButton: 'Запустить кампанию',
  tryAnother: 'Проверить другой сайт',

  error_invalid_url:
    'Не похоже на адрес сайта. Попробуйте в формате yourcompany.com.',
  error_site_unreachable:
    'Не удалось открыть сайт. Проверьте адрес и попробуйте ещё раз.',
  error_site_blocked:
    'Этот адрес нельзя проанализировать. Укажите публичный сайт компании.',
  error_site_empty:
    'На странице слишком мало текста, чтобы понять ваш бизнес. Попробуйте основной сайт.',
  error_no_leads: 'Подходящих людей не нашлось. Измените сегмент или кампанию.',
  error_leads_unavailable: 'Не получилось подобрать людей, попробуйте ещё раз.',
  error_generation_failed:
    'Что-то пошло не так при анализе сайта. Попробуйте ещё раз.',
  error_capacity_reached:
    'На сегодня лимит бесплатных проверок исчерпан. Возвращайтесь завтра или зарегистрируйтесь.',
  error_rate_limited:
    'Слишком много попыток. Подождите несколько минут и попробуйте снова.',
  error_unavailable: 'Мгновенное демо сейчас недоступно.',
  error_expired: 'Этот результат больше недоступен. Запустите проверку заново.',
  error_internal: 'Что-то пошло не так. Попробуйте ещё раз.',

  runTitle: 'Собираем GTM-план для {{domain}}',
  runSubtitle:
    'AI-сотрудник проходит шесть этапов. Результат каждого появляется, как только он готов.',
  runLoading: 'Загружаем прогон…',
  runBack: 'Проверить другой сайт',
  runWorkspace: 'Рабочая область GTM',
  runStagesNav: 'Этапы исследования',
  runResearchTrail: 'Ход исследования',
  runTrailHint: 'Что GTM-сотрудник уже выяснил.',
  runProgress: 'Готово этапов: {{done}} из {{total}}',
  runProgressLabel: 'Прогресс исследования',
  stage_research: 'Изучаем вашу компанию',
  stage_competitors: 'Изучаем конкурентов',
  stage_campaigns: 'Определяем кампании',
  stage_companies: 'Ищем потенциальных клиентов',
  stage_decision_makers: 'Ищем лиц, принимающих решения',
  stage_emails: 'Пишем письма',
  ws_stageDescription_research: 'Компания, предложение и идеальный клиент',
  ws_stageDescription_competitors: 'Альтернативы на рынке и позиционирование',
  ws_stageDescription_campaigns: 'Команды покупателей, заходы и приоритеты',
  ws_stageDescription_companies: 'Компании под выбранные кампании',
  ws_stageDescription_decision_makers: 'Релевантные люди в целевых компаниях',
  ws_stageDescription_emails: 'Письма для подтверждённых получателей',
  stageStatus_pending: 'Ожидает',
  stageStatus_active: 'Выполняется…',
  stageStatus_done: 'Готово',
  stageStatus_missing_contacts:
    'Исследование завершено — проверенных контактов нет',
  stageStatus_failed: 'Остановлено',
  stageSample: 'Пример',
  campaignPrimary: 'Основная',
  campaignShareTitle: 'Рекомендуемая доля бюджета рассылки',
  campaignsNone: 'Не удалось составить кампании для этой компании.',
  buyerTitle: 'Кто покупает',
  buyerProductType_team_tool: 'Инструмент команды',
  buyerProductType_company_wide: 'Общекомпанейский продукт',
  buyerProductTypeHint_team_tool:
    'Решает боль одной функции; покупает руководитель этой функции.',
  buyerProductTypeHint_company_wide:
    'Комплаенс, безопасность, финансы или стратегия компании; покупает C-level.',
  buyerSize: '{{size}} сотрудников',
  buyerExcluded: 'Не писать',
  buyerManual: 'Задано вручную',
  buyerManualHint: 'Вы изменили это вручную; автоматика это не перезапишет.',
  buyerEdit: 'Изменить',
  buyerDialogTitle: 'Кто покупает в компании',
  buyerDialogText:
    'Выберите, кому писать в компании каждого размера, основная роль первой. Ваши настройки сохраняются.',
  buyerProductTypeLabel: 'Тип продукта',
  buyerSave: 'Сохранить',
  buyerCancel: 'Отмена',
  buyerSaveError: 'Не удалось сохранить. Попробуйте ещё раз.',
  buyerNoRoles: 'никому',
  buyerRole_founder: 'Основатель',
  buyerRole_vp: 'Вице-президент {{area}}',
  buyerRole_director: 'Директор {{area}}',
  buyerRole_head: 'Руководитель {{area}}',
  buyerRole_lead: 'Тимлид {{area}}',
  buyerCLevel_leadership: 'CEO',
  buyerCLevel_sales: 'CRO',
  buyerCLevel_marketing: 'CMO',
  buyerCLevel_engineering: 'CTO',
  buyerCLevel_ai_data: 'CDO',
  buyerCLevel_product: 'CPO',
  buyerCLevel_operations: 'COO',
  buyerCLevel_finance: 'CFO',
  buyerCLevel_people: 'CHRO',
  buyerCLevel_it_security: 'CISO',
  buyerCLevel_customer_support: 'CCO',
  buyerArea_leadership: 'руководства',
  buyerArea_sales: 'продаж',
  buyerArea_marketing: 'маркетинга',
  buyerArea_customer_support: 'поддержки',
  buyerArea_engineering: 'разработки',
  buyerArea_ai_data: 'данных',
  buyerArea_product: 'продукта',
  buyerArea_operations: 'операций',
  buyerArea_finance: 'финансов',
  buyerArea_people: 'HR',
  buyerArea_it_security: 'безопасности',
  buyerArea_other: 'операций',
  buyerFitSize: 'компания {{size}} человек',
  buyerFitSizeEstimate: 'компания примерно {{size}} человек (оценка)',
  buyerFitSizeUnknown: 'размер компании неизвестен, считаем 51–200',
  buyerFitTeamTool: 'продукт для отдела {{area}}',
  buyerFitCompanyWide: 'общекомпанейский продукт',
  buyerFitFallback: '{{target}} не нашёлся, следующий по старшинству',
  campaignWho: 'Кому',
  campaignEmployees: '{{sizes}} сотрудников',
  campaignTrigger_hiring: 'Найм',
  campaignTrigger_funding: 'Инвестиции',
  campaignTrigger_expansion: 'Расширение',
  campaignTrigger_leadership_change: 'Новый руководитель',
  campaignTrigger_uses_competitor: 'Пользуется конкурентом',
  campaignVs: 'против {{name}}:',
  campaignProof: 'Доказательство',
  companiesNone: 'Компаний под эти кампании не нашли.',
  companyEmployees_one: '{{count}} сотрудник',
  companyEmployees_few: '{{count}} сотрудника',
  companyEmployees_many: '{{count}} сотрудников',
  companyEmployees_other: '{{count}} сотрудника',
  companyUsesCompetitor: 'Пользуется {{name}}',

  stepLog: 'шаг {{n}}',
  stepOf: 'Шаг {{n}} из {{total}}',
  researchFound: 'Готово',
  researchWorking: 'Изучаем…',
  researchLookingFor: 'Ищем',
  stageWorking: 'Работаем над этим шагом…',
  stageWaiting: 'Этот шаг начнётся после предыдущего.',
  showMore: 'Подробнее',
  showLess: 'Свернуть',
  keywordsLabel: 'Ключевые слова',
  productLabel: 'Продукт',
  queriesLabel: 'Запросы',
  competitorsLabel: 'Конкуренты',
  competitorsInRegion: 'Конкуренты: {{regions}}',
  competitorsInRegionNone: 'Конкурентов, продающих в этих регионах, не нашли.',
  competitorsOther: 'Остальные конкуренты',
  salesRegionsTitle: 'Продаёт в',
  competitorsNone: 'В открытых источниках конкурентов не нашли.',
  competitorVia: 'источник: {{host}}',
  competitorsMore_one: 'и ещё {{count}}',
  competitorsMore_few: 'и ещё {{count}}',
  competitorsMore_many: 'и ещё {{count}}',
  competitorsMore_other: 'и ещё {{count}}',
  previewTitle: 'Что вы получите за две минуты',
  previewSubtitle:
    'Ваш сайт проходит те же шаги, что сделал бы отдел продаж, и вы видите результат каждого.',
  preview_research: 'Читаем ваш сайт: что вы продаёте, кто покупает и почему',
  preview_competitors: 'С кем вы конкурируете и чьих клиентов можно забрать',
  preview_campaigns: 'Кому продавать в первую очередь — с долей бюджета',
  preview_companies: 'Реальные компании под каждую кампанию',
  preview_decision_makers:
    'Те, кто принимает решения, с LinkedIn и проверенным адресом',
  previewSubject: 'расчёт стоимости за минуты, а не дни',

  flowTitle: 'Что происходит после запуска',
  flowText:
    'Кампании, лиды и первые письма переносятся в ваше рабочее место. Вы читаете каждый черновик и нажимаете «Отправить». Письма уходят с прогретых ящиков, закреплённых за вашим аккаунтом, — никогда с вашего домена, до 25 в день с ящика. Ответы приходят во «Входящие», разобранные, с готовым черновиком ответа.',
  flowPointMailbox: 'Прогретые ящики, а не ваш домен',
  flowPointFollowUp: 'Напоминания по расписанию',
  flowPointReplies: 'Ответы разобраны, черновики готовы',
  flowMon: 'Пн',
  flowThu: 'Чт',
  flowFri: 'Пт',
  flowFirstBody:
    'Здравствуйте, Майя! Ваши менеджеры считают доставку вручную по трём системам — на этом этапе сделки и застревают.',
  flowFollowUpBody:
    'Майя, напоминаю о своём письме. Найдёте 15 минут на звонок на следующей неделе?',
  flowReply: 'Интересно. Работает с нашей TMS и сколько займёт внедрение?',
  flowSending: 'Отправляется…',
  flowIncoming: 'Новый ответ…',
  flowDrafting: 'Готовим ответ…',
  flowDraftBody:
    'Майя, да, работает с большинством TMS, внедрение занимает около недели. Удобно созвониться во вторник в 10:30?',

  indexTitle: 'Собственная <accent>база B2B-покупателей</accent>',
  indexText:
    'Каждый запуск добавляет компании, ЛПР и проверенные адреса в наш собственный индекс. Поиск начинается с него, поэтому лиды находятся быстрее, а компанию мы перечитываем, когда меняется её сайт.',
  indexPoint1: 'Сначала ищем у себя, потом во внешних источниках.',
  indexPoint2: 'Каждый адрес проверяется перед использованием.',
  indexPoint3:
    'Поиск лидов и исследование включены: вы платите только за отправленные письма.',

  trustTitle: 'Откуда данные и как мы отправляем',
  trust1Title: 'Только открытые источники',
  trust1Text:
    'Компании и люди — из открытых источников и от проверенных поставщиков данных. Каждый адрес проверяется до отправки первого письма.',
  trust2Title: 'Проверка перед отправкой',
  trust2Text:
    'Каждый адрес проверяется сервисами проверки email. Всё непроверенное проверяется ещё раз до отправки первого письма.',
  trust3Title: 'Отдельные ящики для отправки',
  trust3Text:
    'Письма уходят с проверенных ящиков, закреплённых за вашим аккаунтом, никогда с вашего домена, в безопасном дневном темпе. Ответы приходят во «Входящие» Laplace.',
  trust4Title: 'Отписки соблюдаются',
  trust4Text:
    'Ответ с просьбой больше не писать распознаётся автоматически, и этому человеку мы больше никогда не пишем.',

  testimonialsTitle: 'Что говорят клиенты',

  pricingTitle: 'Оплата по факту, без подписки',
  pricingTopUp: 'Сумма пополнения',
  pricingPerEmail: 'За отправленное письмо',
  pricingPerEmailValue: '${{value}}',
  pricingEmails: 'Писем за ${{budget}}',
  pricingPeople: 'Людей, по 2–3 письма',

  finalTitle: 'Посмотрите, кто может у вас купить',
  finalButton: 'Проанализировать мой сайт',
  ws_navOverview: 'Обзор',
  ws_navCampaigns: 'Кампании',
  ws_navLeads: 'Лиды',
  ws_stage_found: 'Найден',
  ws_stage_queued: 'В очереди',
  ws_stage_contacted: 'Написали',
  ws_stageContactedStep: 'Письмо {{step}} отправлено',
  ws_stage_interested: 'Интерес',
  ws_stage_objection: 'Возражение',
  ws_reserve: 'Резерв',
  ws_reserveRank: 'Резерв №{{rank}}',
  ws_reserveState_waiting: 'ожидает',
  ws_reserveState_busy: 'занят другим клиентом',
  ws_reserveState_unreachable: 'нет адреса',
  ws_reserveState_stopped: 'остановлен',
  ws_stage_no_reply: 'Нет ответа',
  ws_stage_not_now: 'Не сейчас',
  ws_stage_out_of_office: 'Нет на месте',
  ws_stage_meeting_booked: 'Встреча назначена',
  ws_stage_meeting_held: 'Встреча прошла',
  ws_stage_won: 'Сделка',
  ws_stage_lost: 'Не сложилось',
  ws_stage_not_interested: 'Отказ',
  ws_stage_bounced: 'Адрес не работает',
  ws_stage_unsubscribed: 'Отписался',
  ws_next_send_email: 'Отправить следующее письмо',
  ws_next_reply: 'Ответить',
  ws_next_resume: 'Продолжить цепочку',
  ws_next_follow_up: 'Написать после встречи',
  ws_next_attend_meeting: 'Встреча',
  ws_next_recontact: 'Можно написать снова',
  ws_next_none: 'Ничего не запланировано',
  ws_noEmail: 'Адреса пока нет',
  ws_loadingLead: 'Загружаем лида',
  ws_loadingLeadDescription: 'Загружаем данные лида и историю писем.',
  ws_markTitle: 'Отметить, что произошло',
  ws_markSent: 'Письмо {{step}} отправлено',
  ws_notePlaceholder: 'Заметка в историю (необязательно)',
  ws_nextDate: 'Следующая дата (необязательно)',
  ws_updateError: 'Не удалось сохранить. Попробуйте ещё раз.',
  ws_emailsTitle: 'Письма',
  ws_emailStep: 'Письмо {{step}}',
  ws_message_draft: 'черновик',
  ws_message_queued: 'готово к отправке',
  ws_message_sent: 'отправлено',
  ws_message_sending: 'отправляется',
  ws_message_send_unknown: 'проверяем отправку',
  ws_message_failed: 'ошибка отправки',
  ws_removed_person_busy:
    'С этим человеком уже работает другая компания. Подберём вместо него другого.',
  ws_removed_email_invalid:
    'Этот адрес больше не принимает письма. Подберём вместо него другого.',
  ws_removed_email_unverifiable:
    'Этот адрес не удалось подтвердить. Подберём вместо него другого.',
  ws_removed_company_busy:
    'С этой компанией уже идёт переписка. Человек остаётся в резерве компании.',
  ws_emailMaskedHint:
    'Полный адрес откроется после отправки первого письма этому человеку.',
  ws_addressesPaused_no_balance:
    'Новые люди найдены, но адреса и письма для них не готовили: баланс пуст. Они появятся после пополнения.',
  ws_addressesPaused_no_capacity:
    'Новые люди найдены, но адреса и письма для них не готовили: в ящиках нет свободных мест на ближайшие дни. Они появятся, когда места освободятся.',
  ws_searchRefused_free_search_limit:
    'Пополните баланс, чтобы продолжить поиск.',
  ws_dailyLimitReached:
    'Лимит писем за последние 24 часа исчерпан. Черновики сохранены.',
  ws_senderLimitReached:
    'Ящик этого диалога достиг лимита за 24 часа. Попробуйте позже — черновик сохранён.',
  ws_sidebarUsageTitle: 'Использование',
  ws_usageCapacity: 'Лимит писем',
  ws_usageBalance: 'Баланс',
  ws_usageNotAvailable: 'Пока недоступно',
  ws_usageLoadFailed: 'Не удалось загрузить',
  ws_usageCapacityValue:
    'Осталось {{remaining}} из {{total}} за последние 24 часа',
  ws_usageCapacityUsed: 'Отправлено за последние 24 часа',
  ws_usageNextLimit: 'Лимит вырастет до {{limit}} писем в день к {{date}}',
  ws_insufficientBalance: 'На балансе недостаточно средств для письма.',
  ws_send: 'Отправить письмо',
  ws_retrySend: 'Повторить отправку',
  ws_sendError: 'Письмо не отправлено. Попробуйте ещё раз.',
  ws_draftSaved:
    'Черновик ответа сохранён ниже. Проверьте его и нажмите «Отправить».',
  ws_composerFrom: 'От',
  ws_discardChanges: 'Отменить правки',
  ws_unsavedChanges: 'Есть несохранённые правки',
  ws_sendReply: 'Отправить',
  ws_refreshInbox: 'Обновить',
  ws_inboxNoNewReplies: 'Новых ответов нет',
  ws_inboxNewReplies_one: '{{count}} новый ответ',
  ws_inboxNewReplies_few: '{{count}} новых ответа',
  ws_inboxNewReplies_many: '{{count}} новых ответов',
  ws_inboxNewReplies_other: '{{count}} новых ответа',
  ws_inboxRefreshFailed:
    'Не удалось проверить новые ответы. Попробуйте чуть позже.',
  ws_replyComposer: 'Ответ',
  ws_aiDraftTitle: 'Черновик ответа от AI',
  ws_reviewBeforeSend:
    'Проверьте перед отправкой. Черновики не отправляются автоматически.',
  ws_saveDraft: 'Сохранить черновик',
  ws_manualReply: 'Вставить ответ вручную',
  ws_moreActions: 'Действия с лидом и история',
  ws_historyTitle: 'История',
  ws_leadsQueue: 'Очередь рассылки',
  ws_leadsQueueEmpty:
    'Нет проверенных контактов, ожидающих первого письма. Отправленная переписка — во «Входящих».',
  ws_firstEmailChecking: 'Проверяем, доставлено ли письмо.',
  ws_backToLeads: 'Назад к лидам',
  ws_subject: 'Тема',
  ws_you: 'Вы',
  ws_leadsTitle: 'Лиды',
  ws_outreach_start: 'Запустить рассылку',
  ws_outreach_pause: 'Пауза',
  ws_outreach_resume: 'Возобновить',
  ws_outreachToday_one:
    'Сегодня {{count}} письмо: {{followUps}} продолжений и {{fresh}} новых.',
  ws_outreachToday_few:
    'Сегодня {{count}} письма: {{followUps}} продолжений и {{fresh}} новых.',
  ws_outreachToday_many:
    'Сегодня {{count}} писем: {{followUps}} продолжений и {{fresh}} новых.',
  ws_outreachToday_other:
    'Сегодня {{count}} писем: {{followUps}} продолжений и {{fresh}} новых.',
  ws_outreachQueueDays_one: 'Очередь на {{count}} день.',
  ws_outreachQueueDays_few: 'Очередь на {{count}} дня.',
  ws_outreachQueueDays_many: 'Очередь на {{count}} дней.',
  ws_outreachQueueDays_other: 'Очередь на {{count}} дней.',
  ws_outreachReview_one:
    'Режим проверки: готово к отправке {{count}} письмо — отправьте вручную.',
  ws_outreachReview_few:
    'Режим проверки: готово к отправке {{count}} письма — отправьте вручную.',
  ws_outreachReview_many:
    'Режим проверки: готово к отправке {{count}} писем — отправьте вручную.',
  ws_outreachReview_other:
    'Режим проверки: готово к отправке {{count}} писем — отправьте вручную.',
  ws_outreachPaused_no_balance:
    'Письма не уходят: баланс исчерпан. Пополните, чтобы продолжить.',
  ws_outreachPaused_no_mailbox:
    'Письма не уходят: сейчас нет ящика, который может отправлять.',
  ws_outreachRefused_no_mailbox:
    'Сейчас нет ящика, который может отправлять. Попробуйте позже.',
  ws_outreachError: 'Не удалось изменить рассылку. Попробуйте ещё раз.',
  ws_colCompany: 'Компания',
  ws_colCampaign: 'Кампания',
  ws_colEmail: 'Email',
  ws_colStage: 'Статус',
  ws_colNext: 'Дальше',
  ws_campaignsTitle: 'Кампании',
  ws_campaignsText:
    'По одной кампании на команду покупателя. Доля бюджета показывает, куда GTM тратит в первую очередь.',
  ws_colShare: 'Доля бюджета',
  ws_colLeads: 'Лиды',
  ws_colContacted: 'Написали',
  ws_colReplies: 'Ответы',
  ws_colMeetings: 'Встречи',
  ws_tileQueued: 'К отправке',
  ws_tileContacted: 'Написали',
  ws_tileReplied: 'Ответили',
  ws_tileMeetings: 'Встречи',
  ws_dueTitle_one: '{{count}} лид ждёт действия сегодня',
  ws_dueTitle_few: '{{count}} лида ждут действия сегодня',
  ws_dueTitle_many: '{{count}} лидов ждут действия сегодня',
  ws_dueTitle_other: '{{count}} лида ждут действия сегодня',
  ws_dueText:
    'Письма к отправке и ответы, на которые нужно ответить. Отметьте каждое, когда сделаете.',
  ws_dueAction: 'Открыть очередь',
  ws_campaignsCount_one: 'Идёт {{count}} кампания.',
  ws_campaignsCount_few: 'Идут {{count}} кампании.',
  ws_campaignsCount_many: 'Идёт {{count}} кампаний.',
  ws_campaignsCount_other: 'Идут {{count}} кампании.',
  ws_navInbox: 'Входящие',
  ws_navAnalysis: 'Анализ',
  ws_navConversations: 'Переписка',
  ws_navSettings: 'Настройки',
  ws_inboxTitle: 'Входящие',
  ws_inboxEmailText: 'Ответы лидов: сначала последнее входящее письмо.',
  ws_inboxError: 'Не удалось загрузить входящие. Попробуйте снова.',
  ws_inboxText: 'Что GTM ждёт от вас сегодня по {{company}}.',
  ws_inboxEmpty: 'Сейчас ничего не ждёт. Новые письма и ответы появятся здесь.',
  ws_attentionTitle: 'Требует внимания',
  ws_campaignActivity: 'Активность кампаний',
  ws_campaignSummary: '{{contacted}} отправлено · {{replies}} ответов',
  ws_group_reply: 'Ответить',
  ws_group_send: 'Отправить',
  ws_group_resume: 'Вернуться к переписке',
  ws_group_meetings: 'Встречи',
  ws_sendStep: 'Письмо {{step}}',
  ws_open: 'Открыть',
  ws_searchRunning: 'Ищем: {{step}}…',
  ws_searchFailed: 'Поиск не завершился. Попробуйте ещё раз.',
  ws_searchStep_research_company: 'изучаем компанию',
  ws_searchStep_exploring_competitors: 'смотрим конкурентов',
  ws_searchStep_defining_campaigns: 'готовим кампании',
  ws_searchStep_finding_companies: 'ищем компании',
  ws_searchStep_finding_leads: 'ищем ЛПР',
  ws_searchStep_finding_emails: 'ищем адреса',
  ws_searchStep_writing_emails: 'пишем письма',
  ws_searchStep_done: 'заканчиваем',
  ws_replyTitle: 'Ответ лида',
  ws_replyPlaceholder:
    'Вставьте ответ: GTM прочитает его, обновит статус и подготовит черновик ответа.',
  ws_replyRead: 'Разобрать ответ',
  ws_replyReading: 'Читаем…',
  ws_replyReadAs: 'GTM понял ответ как',
  ws_replyNoAnswer: 'Отвечать не нужно. Статус и следующая дата обновлены.',
  ws_answerSubject: 'Тема ответа',
  ws_answerBody: 'Текст ответа',
  ws_answerSent: 'Ответ отправлен',
  ws_answerDiscard: 'Убрать черновик',
  ws_answerHint: 'Отправьте его из своей почты и отметьте здесь.',
  ws_threadTitle: 'Переписка',
  ws_threadEmpty: 'Сообщений пока нет.',
  ws_ourAnswer: 'Наш ответ',
  ws_message_received: 'получено',
  ws_conversationsTitle: 'Переписка',
  ws_conversationsText:
    'Читайте цепочки, редактируйте черновики AI и решайте, что отправлять.',
  ws_conversationList: 'Список переписок',
  ws_selectConversation: 'Выберите переписку, чтобы открыть цепочку.',
  ws_noConversations: 'Переписок пока нет.',
  ws_analysisTitle: 'Анализ',
  ws_analysisText:
    'Исследование компании и стратегия кампаний для этого проекта.',
  ws_analysisEmpty: 'У этого проекта пока нет сохранённого анализа.',
  ws_analysisError:
    'Не удалось загрузить сохранённый анализ. Попробуйте снова.',
  ws_analysisStageEmpty: 'Для этого этапа нет сохранённого результата.',
  ws_emailUnknown: 'статус email неизвестен',
  ws_needsReply: 'Нужен ответ',
  ws_draftsCount_one: '{{count}} черновик',
  ws_draftsCount_few: '{{count}} черновика',
  ws_draftsCount_many: '{{count}} черновиков',
  ws_draftsCount_other: '{{count}} черновика',
  ws_showQuotedHistory: 'Показать цитируемую историю',
  ws_sampleNotSendable: 'Тестовым лидам нельзя отправлять реальные письма.',
  ws_sendingUnavailable: 'Отправка временно недоступна',
  ws_dailyRemaining: 'Сегодня доступно: {{count}}',
  ws_settingsTitle: 'Настройки GTM',
  ws_settingsTabGeneral: 'Общее',
  ws_settingsTabEmails: 'Письма',
  ws_settingsTabSending: 'Рассылка',
  ws_outreachPausedLine: 'Письма ждут, пока вы её не возобновите.',
  ws_outreachStoppedLine_review:
    'После запуска письма будут готовиться каждый рабочий день.',
  ws_outreachStoppedLine_autopilot:
    'После запуска письма будут уходить по расписанию.',
  ws_outreachStatus_paused: 'Рассылка на паузе.',
  ws_outreachStatus_running: 'Рассылка идёт.',
  ws_outreachStatus_stopped: 'Рассылка остановлена.',
  ws_outreachToolbar: 'Рассылка',
  ws_emailStepSummary_3: 'Короткое напоминание; больше не пишем',
  ws_emailStepSummary_2: 'Новый угол или пример, без повтора письма 1',
  ws_emailStepSummary_1: 'Кто вы и почему пишете; в конце вопрос, без созвона',
  ws_sendingTo: 'До',
  ws_sendingFrom: 'С',
  ws_sendingWindow: 'Время отправки',
  ws_sendingSettingsLoading: 'Загружаем настройки рассылки…',
  ws_sendingSettingsError:
    'Не удалось загрузить настройки рассылки. Попробуйте ещё раз.',
  ws_sendingSchedule: 'Расписание',
  ws_sendingGap2: 'Письмо 2 через',
  ws_sendingGap3: 'Письмо 3 через',
  ws_sendingWorkingDays: 'Дни отправки',
  ws_sendingRecipientTime: 'по времени получателя',
  ws_settingsText: 'Контекст компании, баланс и стиль писем.',
  ws_settingsLoading: 'Загружаем настройки GTM…',
  ws_settingsError: 'Не удалось загрузить настройки GTM. Попробуйте снова.',
  ws_companyContext: 'Контекст компании',
  ws_analyzedCompany: 'Проанализированная компания',
  ws_analyzedDomain: 'Проанализированный домен',
  ws_domainUnavailable: 'Недоступно',
  ws_creditDetails: 'Использование и кредиты',
  ws_emailSettingsLoading: 'Загружаем настройки писем…',
  ws_emailSettingsError:
    'Не удалось загрузить настройки писем. Попробуйте ещё раз.',
  ws_emailStep_1: 'Письмо 1 · Знакомство',
  ws_emailStep_2: 'Письмо 2 · Новый угол',
  ws_emailStep_3: 'Письмо 3 · Напоминание',
  ws_sendingDefaultsFit: 'Значения по умолчанию подходят большинству.',
  ws_emailTone_soft: 'Мягкий',
  ws_emailTone_formal: 'Формальный',
  ws_emailTone_conversational: 'Разговорный',
  ws_emailsEditOnLeads:
    'Отдельное письмо можно поправить в черновике лида на странице Leads.',
  ws_save: 'Сохранить',
  ws_cancel: 'Отмена',
  ws_saved: 'Сохранено',
  ws_tryAgain: 'Не получилось, попробуйте ещё раз.',
  ws_emailPreviewLoading: 'Пишем письмо…',
  ws_emailPreviewExample: 'пример',
  ws_sendingFewerDays: 'На день меньше',
  ws_sendingMoreDays: 'На день больше',
  ws_sendingBusinessDays_one: 'рабочий день',
  ws_sendingBusinessDays_few: 'рабочих дня',
  ws_sendingBusinessDays_many: 'рабочих дней',
  ws_sendingBusinessDays_other: 'рабочих дня',
  ws_emailTone: 'Тон',
  ws_draftIssue_meetingAsk:
    'Просит созвон в первом письме: не уйдёт, пока вы не поправите или не отправите сами.',
  ws_draftIssue_inventedNumbers:
    'Цифры не из ваших фактов: {{numbers}}. Не уйдёт, пока вы их не проверите.',
  ws_draftIssue_bannedPhrases:
    'Шаблонные фразы, лучше переписать: {{phrases}}.',
  ws_projectsEmpty: 'Проектов пока нет',
  ws_projectsError: 'Не удалось загрузить GTM-проекты. Повторите попытку.',
  ws_projects: 'Проекты',
  ws_campaignLabel: 'Кампания: {{name}}',
  ws_openCampaignStrategy: 'Открыть стратегию кампании в «Анализе»',
  ws_campaignProgress: 'Прогресс кампании',
  ws_project: 'Проект',
  ws_projectSearch: 'Поиск проектов',
  ws_newProject: 'Новый проект',
  ws_newProjectDescription:
    'Введите сайт компании. После подтверждения начнётся существующий анализ из шести этапов; он может использовать настроенные внешние провайдеры.',
  ws_newProjectError:
    'Не удалось создать проект. Проверьте сайт и повторите попытку.',
  ws_startProjectAnalysis: 'Запустить анализ',
  cancel: 'Отмена',
  ws_creditsPurchased: 'Куплено кредитов',
  ws_sendCost: 'Цена успешной отправки',
  ws_availableCredit: 'Доступный кредит',
  ws_creditedCapacity: 'Начисленная ёмкость',
  ws_hireButton: 'Нанять сотрудника',
  ws_hireTitle: 'Нанять цифрового сотрудника',
  ws_hireText:
    'Сотрудник работает внутри этого воркспейса и платит из баланса организации.',
  ws_hireGtmText:
    'Находит компании и ЛПР, пишет письма, разбирает ответы и назначает встречи.',
  ws_hireUrlLabel: 'Сайт вашей компании',
  ws_hireGtm: 'Нанять GTM',
  ws_hireHint: 'Около двух минут: GTM изучит сайт и найдёт первых лидов.',
  ws_hireForbidden: 'Нанимать сотрудников могут только админы воркспейса.',
  ws_hireBadUrl: 'Проверьте адрес сайта и попробуйте ещё раз.',
  ws_soon: 'Скоро',
  ws_employee_tender_scout: 'Tender Scout',
  ws_employee_tender_scout_text: 'Находит подходящие тендеры и готовит заявку.',
  ws_employee_secure_by_design: 'Secure by Design',
  ws_employee_secure_by_design_text:
    'Проверяет репозитории, находит уязвимости и предлагает исправления.',

  // Сначала оплата, потом регистрация (LP-272).
  checkoutPay: 'Оплатить ${{amount}}',
  checkoutPayTest: 'Оплатить ${{amount}} (тестовый платёж)',
  checkoutPayNote:
    'Безопасная оплата через Paddle. Аккаунт создаётся сразу после оплаты.',
  checkoutTestNote: 'Тестовый режим: деньги не списываются.',
  checkoutEmails: '≈ {{emails}} писем по ${{price}}',
  checkoutConfirming: 'Подтверждаем оплату…',
  checkoutConfirmingSlow: 'Оплата ещё подтверждается. Страница обновится сама.',
  checkoutCanceled: 'Оплата не завершена. Можно попробовать ещё раз.',
  checkoutPaidTitle: 'Оплата получена',
  checkoutPaidText: '${{amount}} ждут ваш аккаунт. Создайте его, чтобы начать.',
  checkoutContinueToWorkspace: 'Перейти в GTM-workspace',
  checkoutCreateAccount: 'Создать аккаунт',
  checkoutContinueToPayment: 'Перейти к оплате',
  checkoutChangeAmount: 'Изменить сумму',
  checkoutSummaryItem: 'Кредиты Laplace GTM',
  checkoutSummarySubtotal: 'Без налога',
  checkoutSummaryTax: 'Налог',
  checkoutSummaryTotal: 'К оплате сегодня',
  checkoutSummaryTaxNote:
    'Налог вашей страны добавляется сверху; Paddle покажет его до оплаты.',
  checkoutAccountRequired:
    'Чтобы оплатить, заполните данные аккаунта и примите условия справа.',
  checkoutGuestText:
    'Заполните один раз: аккаунт создаётся, как только пройдёт оплата. Paddle примет оплату с этим email.',
  startPaymentPending: 'Ждём подтверждения оплаты…',
  startProofTitle: 'Используйте email, с которым платили',
  startProofText:
    'Покупка оплачена с другого email. Зарегистрируйтесь с email, указанным при оплате, или откройте ссылку в браузере, где платили.',
  startPaymentRequired: 'Эта покупка ещё не оплачена.',

  // Баланс и платежи в рабочем месте (LP-272).
  ws_topUp: 'Пополнить',
  ws_topUpTitle: 'Пополнить баланс',
  ws_topUpText:
    'Любая целая сумма от ${{min}}. Кредиты не сгорают, пока аккаунт активен.',
  ws_topUpAmount: 'Сумма, USD',
  ws_topUpAmountError: 'Введите целую сумму от ${{min}} до ${{max}}.',
  ws_topUpEmails: '≈ {{emails}} писем',
  ws_topUpPay: 'Оплатить ${{amount}}',
  ws_topUpPayTest: 'Оплатить ${{amount}} (тестовый платёж)',
  ws_topUpDone: '${{amount}} зачислено на баланс.',
  ws_topUpPending: 'Оплата подтверждается. Баланс обновится через минуту.',
  ws_topUpError: 'Пополнить не удалось. Попробуйте ещё раз.',
  ws_balanceRunsOut: 'Закончится ~{{date}}',
  ws_balanceLowTitle: 'Баланс заканчивается',
  ws_balanceLowText:
    'Осталось {{emails}} писем, примерно до {{date}}. Пополните баланс, чтобы рассылка не встала.',
  ws_balanceLowTextNoDate:
    'Осталось {{emails}} писем. Пополните баланс, чтобы рассылка не встала.',
  ws_balanceDepletedTitle: 'Баланс исчерпан: поиск и отправка на паузе',
  ws_balanceDepletedText:
    'Черновики и ответы сохранены. Пополните баланс, чтобы продолжить.',
  ws_billingTitle: 'Баланс и платежи',
  ws_billingText:
    '${{price}} за отправленное письмо — любое: первое, продолжение или ответ. Поиск лидов, исследование и черновики входят в цену.',
  ws_topUpsTitle: 'Пополнения',
  ws_topUpsEmpty: 'Пополнений пока нет.',
  ws_topUpsLoadFailed: 'Не удалось загрузить платежи.',
  ws_topUpStatus_pending: 'ожидает оплаты',
  ws_topUpStatus_completed: 'оплачено',
  ws_topUpStatus_canceled: 'отменено',
  ws_topUpStatus_failed: 'ошибка',
  ws_topUpTestBadge: 'тест',
  ws_refunded: 'Возвращено {{amount}}',
  ws_refundPending: 'Возврат {{amount}} в обработке',
}
